<template>
    <div class='moduleMain'>
     <div class='module_base_title'>
       <div class='big_title'>在线PDF转换器</div>
       <div class='small_title'>几秒内文档轻松转为PDF, 支持Word, Excel, PPT在线转为PDF</div>
     </div>
     <div class='touch_block'>
       <div class='touch_block_core'>
          <div class='core_btn' @click='clickLoad' v-if='!isConvert'>
            <input type="file" id="files" ref="refFile" accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx" style="display:none" v-on:change="fileLoad">
             <div class='left_plus'>
               <div class='horizontally'></div>
               <div class='vertical'></div>
             </div>
             <div class='btn_text'>选择文件</div>
             <div class='right_plus'>
              <div class='horizontally'></div>
              <div class='vertical'></div>
             </div>
           </div>
           <div class='core_text' v-if='!isConvert'>点击上方按钮选择文件或拖拽文件到此处</div>
           <div class='down_text' v-if='isConvert'>
             <div v-if='!isCompleted'>转换中,请耐心等待~</div>
             <div v-if='isCompleted'>转换成功，请点击下方按钮下载</div>
           </div>
           <div :class='{down_btn_covert:!isCompleted,down_btn_completed:isCompleted}' @click='download' v-if='isConvert'>
             <div class='completed_btn_text'>
              <div v-if='!isCompleted'>文件转换中 . . .</div>
              <div v-if='isCompleted'>下载文件</div>
             </div>
           </div>
           <div :class='{restart_btn_completed:isCompleted}' @click='restart' v-if='isCompleted'>
            <div class='completed_btn_text'>
             <div v-if='isCompleted'>继续转换</div>
            </div>
           </div>
       </div>
     </div>
    </div>
</template>

<script>
import cookie from '../common/cookie'
import { convertApi } from '@/components/convert/convert'

export default {
  name: 'other2pdf',
  data () {
    return {
      timer: null,
      taskId: '',
      downloadUrl: '',
      isConvert: false,
      isCompleted: false,
      fileName: ''
    }
  },
  components: {
    cookie
  },
  methods: {
    onDrag: function (e) {
      e.stopPropagation()
      e.preventDefault()
    },
    onDrop: function (e) {
      e.stopPropagation()
      e.preventDefault()
      var dt = e.dataTransfer
      if (dt.files.length !== 1) {
        this.$emit('msgShow', '当前不支持批量转换')
        return
      }
      if (dt.files[0].size > 125829120) {
        this.$emit('msgShow', '仅支持最大120M的文件')
        return
      }
      this.uploadFile(dt.files[0])
    },
    async uploadFile (file) {
      this.isConvert = true
      this.fileName = file.name.substr(0, file.name.indexOf('.'))
      let result = await convertApi.convertToPdf(file)
      if (result.code === 100004) {
        this.isConvert = false
        this.$emit('show')
        return
      }
      if (result.code === 0) {
        this.taskId = result.data
        this.covertToPdfPolling()
      } else {
        this.isConvert = false
        this.$emit('msgShow', result.msg)
      }
    },
    covertToPdfPolling () {
      let req = {}
      req.taskId = this.taskId
      if (!this.timer) {
        this.timer = setInterval(async () => {
          let result = await convertApi.getConvertPdf(req)
          if (result.code !== 0) {
            clearInterval(this.timer)
            this.timer = null
            if (result.code === 100004) {
              this.$emit('show')
            }
            this.$emit('msgShow', result.msg)
          } else {
            if (!this.$blankValid.isBlank(result.data)) {
              this.downloadUrl = result.data
              clearInterval(this.timer)
              this.timer = null
              this.isCompleted = true
            }
          }
        }, 5000)
      }
    },
    clickLoad () {
      this.$refs.refFile.dispatchEvent(new MouseEvent('click'))
    },
    fileLoad () {
      const selectedFiles = this.$refs.refFile.files
      if (selectedFiles.length !== 1) {
        this.$emit('msgShow', '当前不支持批量转换')
        return
      }
      if (selectedFiles[0].size > 125829120) {
        this.$emit('msgShow', '仅支持最大120M的文件')
        return
      }
      this.uploadFile(selectedFiles[0])
    },
    async download () {
      const res = await fetch(this.downloadUrl)
      const blob = await res.blob()
      const urlBlob = window.URL.createObjectURL(blob)
      const element = document.createElement('a')
      element.href = urlBlob
      element.download = this.fileName
      element.style.display = 'none'
      element.click()
      element.remove()
    },
    restart () {
      this.isConvert = false
      this.isCompleted = false
      this.fileName = ''
    }
  },
  mounted () {
    var dropbox = document.querySelector('.touch_block_core')
    dropbox.addEventListener('dragenter', this.onDrag, false)
    dropbox.addEventListener('dragover', this.onDrag, false)
    dropbox.addEventListener('drop', this.onDrop, false)
  }
}
</script>

<style scoped>
  .moduleMain {
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .module_base_title {
    width: 40%;
    height: 80px;
    min-width: 400px;
    display: inline-block;
    margin-top:10px;
  }
  .big_title {
    width: 100%;
    height: 40px;
    min-width: 400px;
    font-size: 40px;
    font-family: PingfangScBold;
    font-weight: 500;
    color: #46495f;
    letter-spacing: 2px;
    text-align: center;
    display: block;
  }
  .small_title {
    width: 100%;
    height: 40px;
    min-width: 400px;
    font-size: 15px;
    font-family: PingfangScBold;
    font-weight: 500;
    color: #60637b;
    letter-spacing: 2px;
    text-align: center;
    display: block;
    margin-top:40px;
  }
  .touch_block {
    width: 80%;
    height: 350px;
    min-width: 1010px;
    display: inline-block;
    text-align: center;
  }
  .touch_block_core {
    width: 580px;
    height: 80%;
    border-radius: 40px;
    box-shadow: 0px 9px 30px 0px #ffe3e0;
    border: 2px solid #f7b8b1;
    display: inline-block;
    text-align: center;
    position: relative;
    top:50%;
    transform:translateY(-50%);
  }
  .core_btn {
    width: 320px;
    height: 60px;
    margin-top:65px;
    border-radius: 18px;
    background: #fc5e4c;
    display: inline-block;
    text-align: center;
    cursor: pointer;
  }
  .btn_text {
    width: 250px;
    display: inline-block;
    position: relative;
    top:35%;
    opacity: 1;
    font-size: 15px;
    font-family: PingfangScBold;
    font-weight: 500;
    color: #ffffff;
  }
  .completed_btn_text {
  width: auto;
  display: inline-block;
  position: relative;
  top:35%;
  opacity: 1;
  font-size: 15px;
  font-family: PingfangScBold;
  font-weight: 500;
  color: #ffffff;
}
  .left_plus {
    width: 15px;
    height: 15px;
    position: relative;
    top:50%;
    transform:translateY(-50%);
    display: inline-block;
  }
  .right_plus {
    width: 15px;
    height: 15px;
    position: relative;
    top:50%;
    transform:translateY(-50%);
    display: inline-block;
  }
  .btn_text {
    width: 250px;
    display: inline-block;
    position: relative;
    top:35%;
    opacity: 1;
    font-size: 15px;
    font-family: PingfangScBold;
    font-weight: 500;
    color: #ffffff;
  }
  .core_text {
    width: 100%;
    height: 40px;
    min-width: 200px;
    font-size: 12px;
    font-family: PingfangScBold;
    font-weight: 300;
    color: #fc5e4c;
    letter-spacing: 2px;
    text-align: center;
    margin-top:55px;
  }
  .down_text {
    width: 100%;
    height: 40px;
    min-width: 200px;
    font-size: 15px;
    font-family: PingfangScBold;
    font-weight: 300;
    color: #fc5e4c;
    letter-spacing: 2px;
    text-align: center;
    margin-top:65px;
  }
  .down_btn_covert {
    width: 320px;
    height: 60px;
    border-radius: 18px;
    background: #f7b8b1;
    display: inline-block;
    text-align: center;
    margin-top: 10px;
  }
  .down_btn_completed {
  width: 180px;
  height: 60px;
  border-radius: 18px;
  background: #fc5e4c;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin-top: 10px;
}
.restart_btn_completed {
  width: 180px;
  height: 60px;
  border-radius: 18px;
  background: #fc5e4c;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin-top: 10px;
  margin-left: 30px;
}
  .vertical {
    width: 1px;
    height: 100%;
    opacity: 1;
    border: 1px solid #ffffff;
    position: absolute;
    z-index: 1;
    left: 45%;
  }
  .horizontally {
    width: 100%;
    height: 1px;
    opacity: 1;
    border: 1px solid #ffffff;
    position: absolute;
    z-index: 2;
    top: 45%;
  }
</style>



// WEBPACK FOOTER //
// src/components/convert/other2pdf.vue